<template>
<div>
	<div class="row">
		<div class="col-md-12">
			<div class="white-box">
				<div class="row">
					<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
						<h3 class="box-title pull-left">
							Condiciones de pago
						</h3>
						<div class="btn-toolbar pull-right" role="toolbar">
							<div class="btn-group m-r-20" role="group">
								<button @click="reload()" type="button" class="btn btn-default">
									<i class="fa fa-refresh" aria-hidden="true"></i>
								</button>
								<button @click="$refs.PaymentCondition.open()" type="button" class="btn btn-default">
									<i class="fa fa-plus" aria-hidden="true"></i>
								</button>
							</div>
						</div>
					</div>
				</div>

				<div class="row">
					<div class="col-md-12">
						<loading :active="loading">
							<img :src="$env.ROOT + '/img/loading.gif'" width="55px" height="55px">
						</loading>

						<template v-if="paymentConditions">
							<template v-if="paymentConditions.length">
								<div class="table-responsive">
									<table class="table table-hover table-striped table-condensed">
										<thead>
											<tr>
												<th>ID</th>
												<th>Título</th>
												<th>Principal</th>
												<th>Author</th>
												<th>Fecha</th>
												<th></th>
											</tr>
										</thead>
										<tbody>
											<template v-for="paymentCondition in paymentConditions">
												<tr>
													<td>{{ paymentCondition.id }}</td>
													<td>{{ paymentCondition.title }}</td>
													<td>
														<template v-if="paymentCondition.main">
															<i class="fa fa-check" aria-hidden="true"></i>
														</template>
													</td>
													<td>
														<template v-if="paymentCondition.author">
															<template v-if="paymentCondition.author.profile">
																<img
																	v-if="paymentCondition.author.profile.avatar"
																	:title="paymentCondition.author.email"
																	:src="paymentCondition.author.profile.avatar"
																	class="img-circle" width="30">
																<i v-else :title="paymentCondition.author.email" aria-hidden="true" class="fa fa-user-circle-o"></i>
															</template>
														</template>
													</td>
													<td>
														<template v-if="paymentCondition.created_at">
															{{ paymentCondition.created_at | moment(false) }}
														</template>
													</td>
													<td>
														<div class="btn-group pull-right">
															<button v-on:click="$refs.PaymentCondition.open(paymentCondition)" type="button" class="btn btn-info">
																<i class="fa fa-pencil-square-o" aria-hidden="true"></i>
															</button>
															<button :disabled="paymentCondition.main == true" v-on:click="destroy(paymentCondition)" type="button" class="btn btn-danger">
																<i class="fa fa-trash" aria-hidden="true"></i>
															</button>
														</div>
													</td>
												</tr>
											</template>
										</tbody>
									</table>
								</div>
							</template>
						</template>
					</div>
				</div>
			</div>
		</div>
	</div>

	<payment-condition
		ref="PaymentCondition"
		@reload="reload"
		:user="user"
		:isAuth="isAuth">
	</payment-condition>
	<!--
	<edit
		ref="edit"
		@reload="reload"
		:user="user"
		:isAuth="isAuth">
	</edit>
	-->
</div>
</template>

<script>
	import swal from 'sweetalert2'
	import VueElementLoading from 'vue-element-loading'
	import PaymentCondition from './PaymentCondition'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'loading': VueElementLoading,
			'payment-condition': PaymentCondition,
		},
		data () {
			return {
				loading: false,
				paymentConditions: null,
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				this.getPaymentConditions()
			},
			reload() {
				this.getPaymentConditions()
			},
			getPaymentConditions() {
				this.loading = true
				this.$http.get('admin/management/budgets/payment/conditions')
				.then(response => {
					this.paymentConditions = response.body
					this.loading = false
				})
			},
			destroy(condition) {
				if(!condition.main) {
					var that = this
					swal.queue([{
						title: that.$t("messages.attention"),
						text: that.$t("messages.item_can_not_be_retrieved"),
						type: "warning",
						showCancelButton: true,
						confirmButtonColor: "#53e69d",
						cancelButtonColor: "#ff7676",
						confirmButtonText: "Si",
						cancelButtonText: "No",
						showLoaderOnConfirm: true,
						preConfirm: function () {
							return new Promise(function (resolve) {
								that.$http.delete('admin/management/budgets/payment/conditions/' + condition.id)
								.then(response => {
									that.reload()
									swal(response.body.title, response.body.text, response.body.type);
								}).catch(function(response) {
									console.log(response)
								})
							})
						}
					}]).catch(swal.noop)
				}
			},
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/management/paymentConditions/views/Index.vue